"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePublisher = makePublisher;
exports.makeContextBuilder = makeContextBuilder;
exports.makeDriverConfigBuilder = makeDriverConfigBuilder;
exports.makeErrorHandler = makeErrorHandler;
exports.default = void 0;

var KatalMetrics = _interopRequireWildcard(require("@katal/metrics"));

var _metricsDriverSushi = _interopRequireDefault(require("@katal/metricsDriverSushi"));

var _detectDomainRealm = _interopRequireDefault(require("./detectDomainRealm"));

var DEFAULT_SITE = 'SellerCentral';
var SC_PRODUCER = 'katal_sellercentral';
var SC_SOURCE_GROUPS = {
  test: 'com.amazon.eel.katal.metrics.core.nexus.sellercentral.gamma',
  prod: 'com.amazon.eel.katal.metrics.core.nexus.sellercentral'
};
var ADDITIONAL_UE_LOG_ERROR_INFO = {
  logLevel: 'ERROR',
  // This can be used to whitelist metrics with breakdown by attribution
  attribution: 'KatalMetrics',
  message: 'Metrics Failure'
};

/**
 * Make an initial publisher for the given serviceName.  You should pass in your pageType as serviceName.
 *
 * Most applications will only ever call this method.
 *
 * @param serviceName Service name for metrics context.  You should use your pageType.
 * @returns Katal Metrics publisher configured for the given page and current Seller Central site
 */
function makePublisher(serviceName) {
  var errorHandler = makeErrorHandler();
  var driverConfigBuilder = makeDriverConfigBuilder(errorHandler);
  var contextBuilder = makeContextBuilder(serviceName, errorHandler);
  return new KatalMetrics.Publisher(driverConfigBuilder.build(), errorHandler, contextBuilder.build());
}
/**
 * Make a context builder for the given service name.
 *
 * You only need to call this if you want to customize the default context.  Most applications will not need to do that.
 *
 * @param serviceName Service name for metrics context.  You should use your pageType.
 * @param errorHandler Error handler function
 * @return Metrics context builder configured for the current Seller Central page and the given serviceName
 */


function makeContextBuilder(serviceName, errorHandler) {
  if (!serviceName) {
    throw new Error("KatalMetricsSellerCentral.makeContextBuilder requires a serviceName parameter");
  }

  var contextBuilder = new KatalMetrics.Context.Builder();
  contextBuilder.withSite(DEFAULT_SITE);

  if (window.ue_id) {
    contextBuilder.withRelatedMetrics(new KatalMetrics.Metric.String('http_request_id', window.ue_id));
  } else {
    if (errorHandler) {
      errorHandler(new Error("KatalMetricsSellerCentral could not detect http_request_id"));
    }
  } // Can't autodetect pageType/serviceName because ue_pty is set at the bottom of the page


  contextBuilder.withServiceName(serviceName);
  return contextBuilder;
}
/**
 * Make a driver configuration builder.
 *
 * You only need to call this if you want to customize the default context.  Most applications will not need to do that.
 *
 * @param errorHandler Error handler function
 * @return Sushi driver builder configured for the current Seller Central page
 */


function makeDriverConfigBuilder(errorHandler) {
  var domainRealm = (0, _detectDomainRealm.default)();

  if (errorHandler) {
    if (!domainRealm.domain) {
      errorHandler(new Error("KatalMetricsSellerCentral could not auto-detect domain for metrics"));
    }

    if (!domainRealm.realm) {
      errorHandler(new Error("KatalMetricsSellerCentral could not auto-detect realm for metrics"));
    }
  } // If we couldn't autodetect domain or realm, we already logged an error above
  // Now just use defaults, because some metrics are better than no metrics.


  var domain = domainRealm.domain || 'prod';
  var realm = domainRealm.realm || 'USAmazon';
  var builder = new _metricsDriverSushi.default.Builder().withCustomProducer(SC_PRODUCER).withCustomSourceGroup(SC_SOURCE_GROUPS[domain]).withDomainRealm(domain, realm);

  if (errorHandler) {
    builder.withErrorHandler(errorHandler);
  }

  return builder;
}
/**
 * Create an error handler that uses the CSM window.ueLogError if it is available, and otherwise throws an exception.
 *
 * You only need to call this if you want to supplement the default error handling.  Most applications will not need to do that.
 *
 * @return Error handler function
 */


function makeErrorHandler() {
  return function (err) {
    if (!window.ueLogError) {
      throw new Error("KatalMetricsSellerCentral could not find window.ueLogError to handle error: ".concat(err.message));
    }

    window.ueLogError(err, ADDITIONAL_UE_LOG_ERROR_INFO);
  };
} // This keeps things compatible with the previous static class implementation,
// but without the class overhead


var _default = {
  makePublisher: makePublisher,
  makeContextBuilder: makeContextBuilder,
  makeDriverConfigBuilder: makeDriverConfigBuilder,
  makeErrorHandler: makeErrorHandler
};
exports.default = _default;